import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/_services';

@Component({
  selector: 'volkshandwerker-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  isCollapsed = true;

  constructor(
    private router: Router,
    public accountService: AccountService
  ) {
    router.events.subscribe(val => {
      this.isCollapsed = true;
    });
  }

  mobileView() {
    if (window.innerWidth < 992) {
      return true;
    }
    return false;
  }

  ngOnInit() { }

  logout(): void {
    this.accountService.logout();
    this.router.navigate(['']);
  }
}
